import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { get } from 'lodash';
import { Card } from '@youngcapital/component-library';

import withTranslation from '../helpers/withTranslation';
import withOptionsData from '../helpers/withOptionsData';

export function asFieldset(Fieldset, options = {}) {
  const { optionsData } = options;
  const FieldsetWithData = optionsData ? withOptionsData(Fieldset) : Fieldset;
  const FieldsetWithTranslation = withTranslation()(FieldsetWithData);

  return class extends Component {
    // eslint-disable-next-line react/static-property-placement
    static propTypes = {
      form: PropTypes.shape({
        values: PropTypes.object,
        handleChange: PropTypes.func,
        handleBlur: PropTypes.func,
        setFieldValue: PropTypes.func,
        setFieldTouched: PropTypes.func,
        errors: PropTypes.object,
        touched: PropTypes.object
      }).isRequired,
      isTop: PropTypes.bool
    };

    static validationSchema = Fieldset.validationSchema;

    static initialValues = Fieldset.initialValues;

    static type = Fieldset.type;

    getFieldProps = (name, mutateFn = obj => obj) => {
      const {
        values,
        handleChange,
        handleBlur,
        setFieldValue,
        setFieldTouched
      } = this.props.form;
      return mutateFn({
        id: name,
        name,
        value: get(values, name),
        onBlur: handleBlur,
        onChange: handleChange,
        validationMessage: this.getValidationMessage(name),
        validationState: this.getValidationState(name),
        setValue: val => setFieldValue(name, val),
        setTouched: () => setFieldTouched(name, true),
        setUntouched: () => setFieldTouched(name, false)
      });
    };

    getValidationMessage(name) {
      const { errors, touched } = this.props.form;
      if (!get(errors, name)) return '';
      if (!get(touched, name)) return '';
      return get(errors, name);
    }

    getValidationState(name) {
      const { errors, touched } = this.props.form;
      if (!get(touched, name)) return undefined;
      if (!get(errors, name)) return 'success';
      return 'error';
    }

    render() {
      return (
        <Card
          cardWrapperProps={{
            element: 'fieldset',
            className: classNames(this.props.isTop && 'mt-md-4x'),
            id: `fieldset-${Fieldset.type}`
          }}
        >
          <FieldsetWithTranslation
            getFieldProps={this.getFieldProps}
            {...this.props}
          />
        </Card>
      );
    }
  };
}

export const FIELDSET_PROPTYPES = {
  getFieldProps: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  options: PropTypes.object
};
